import React from "react";
import {useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState} from "recoil";
import BaseModal from "./BaseModal";
import activeModalState from "../../state/ui/activeModalState";
import useOuterClick from "../../hooks/ui/useOuterClick";
import accessTokenState from "../../state/accessTokenState";
import queryClient from "../../services/queryClient";
import {useParams} from "react-router-dom";
import loggedOutState from "../../state/loggedOutState";
import windowDimensionState from "../../state/ui/windowDimensionState";
import { useTranslation } from "react-i18next";

export default function ExitModal() {
  const {t} = useTranslation('lounge')
  const [activeModal, setShowModal] = useRecoilState(activeModalState);
  const setLoggedOut = useSetRecoilState(loggedOutState);
  const windowDimensions = useRecoilValue(windowDimensionState);

  const innerRef = useOuterClick(ev => {
    windowDimensions.width > 768 ? setShowModal(''):setShowModal('profile');
  });

  return (
    <BaseModal show={activeModal === 'exit'} center autoHeight>
      <div className="w-full text-center" ref={innerRef}>
        <h4 className="font-bold mb-3 text-lg">{t('exit-the-show')}</h4>
        <div className="flex flex-row flex-wrap">
            <div className="flex-1 mr-1">
                <button 
                  onClick={()=>
                    windowDimensions.width > 768 ? setShowModal(''):setShowModal('profile')
                  } 
                  className="py-2 w-full bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200">
                    {t('cancel')}
                </button>
            </div>
            <div className="flex-1 ml-2">
                <button onClick={()=> {
                  setShowModal('');
                  setLoggedOut(true);
                }} className="py-2 w-full bg-red-500 text-white rounded-lg hover:bg-red-600">{t('exit')}</button>
            </div>
        </div>
      </div>
    </BaseModal>
  )
}
